import { FormItem, Stack, Text } from '@heathmont/moon-components';
import FormError from '~/client/shared/form/FormError';
import FormInput from '~/client/shared/form/FormInput';
import FormReCAPTCHA from '~/client/shared/form/FormReCAPTCHA';
import Translate from '~/client/shared/i18n/Translate';
import type AuthStepsEnum from './AuthStepsEnum';
import useLoginOrSignupStep from './hooks/useLoginOrSignupStep';
import SubmitButtonFormItem from './shared/SubmitButtonFormItem';

type Props = {
  onContinueClick: (step: AuthStepsEnum) => void;
  isPopover?: boolean;
};

const LoginOrSignupStep: FC<Props> = ({ onContinueClick, isPopover }) => {
  const {
    captchaRequired,
    recaptchaRef,
    control,
    required,
    errors,
    loading,
    isSubmitDisabled,
    handleSubmit,
    handleUserNameChange,
  } = useLoginOrSignupStep({ onContinueClick });

  return (
    <form>
      <Stack space="medium">
        {isPopover && (
          <Stack>
            <Text>
              <Translate id="casino.please_login_to_play_for_real" />
            </Text>
          </Stack>
        )}
        <FormInput
          {...required('username')}
          type="text"
          placeholder="profile.username_or_email"
          autoCapitalize="off"
          error={errors?.username?.message || errors?.email?.message}
          inputSize="xlarge"
          name="username"
          onChange={handleUserNameChange}
        />
        {captchaRequired && (
          <FormReCAPTCHA
            recaptchaRef={recaptchaRef}
            name="captcha"
            control={control}
            error={errors?.captcha?.message}
            rules={{
              required: captchaRequired && 'errors.input.required',
            }}
          />
        )}
        <SubmitButtonFormItem
          loading={loading}
          isSubmitDisabled={isSubmitDisabled}
          handleSubmit={handleSubmit}
          dataTestId="submit-login"
          translateId="profile.continue"
        />
        <FormItem>
          {errors?.global?.message && (
            <FormError
              message={errors.global.message}
              data-testid={errors?.global?.message}
            />
          )}
        </FormItem>
      </Stack>
    </form>
  );
};

export default LoginOrSignupStep;
